import { render, staticRenderFns } from "./CmsPrimarySecondaryBanners.vue?vue&type=template&id=64015628&scoped=true"
import script from "./CmsPrimarySecondaryBanners.vue?vue&type=script&lang=js"
export * from "./CmsPrimarySecondaryBanners.vue?vue&type=script&lang=js"
import style0 from "./CmsPrimarySecondaryBanners.vue?vue&type=style&index=0&id=64015628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64015628",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcms-primary-secondary-banners%2FCmsPrimarySecondaryBanners.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports